// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 590 ? "main" : chunkId) + "." + {"590":"f0943c4e1d3195ea71d7","776":"d70d91f71d7938d3b3c3"}[chunkId] + ".css";
};